import React, { useMemo, useState } from 'react'
import "./style.css"
import { useAddServiceArea, useGetALLServiceArea } from '../../hooks/service-area';

import { DatePicker, Divider, Switch, message } from "antd";
import moment from "moment";
const { TimePicker } = DatePicker;

const ServiceArea = ({ editableData }) => {

  const { setController } = useGetALLServiceArea();
  const { mutate, loading, response } = useAddServiceArea();

  const [state, setState] = useState({
    id: null,
    active_status: true,
    area_name: "",
    expand_area_range: 0,
    in_charge_name: "",
    office_address: "",
    office_phone: "",
    srv_center_lat: '',
    srv_center_lng: '',
    email: '',
    password: "",

    // updates===============
    base_fare:0,
    per_km_fare:0,
    reason:"",
    zone_type:"residential",
    zone_start_time: null,
    zone_close_time: null,
    autometic_on_off:false,
    next_op_cl_time:""
  });


  useMemo(() => {
    setController(new Date().getTime())
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [response]);

  useMemo(() => {
    if (editableData) {
      setState(editableData)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [editableData]);

  


  function onChange({ target: { value, name } }) {
    setState(p => ({ ...p, [name]: value }));
  }

  function addServiceArea() {
    mutate(state, data => {
      if(data?.success){
        message.success(data?.message)
      }else{
        message.error(data?.message)
      }
    })
  }
  



  return (
    <>

      <form className="form">
        <div className="form-group">
          <label htmlFor="name">Area Name</label>
          <input value={state.area_name} onChange={onChange} type="text" name="area_name" placeholder="" />
        </div>
        <div className="form-group">
          <label htmlFor="email">Center Lattitude</label>
          <input value={state.srv_center_lat} onChange={onChange} type="text" name="srv_center_lat" placeholder="" />
        </div>
        <div className="form-group">
          <label htmlFor="longitude">Center Longitude</label>
          <input value={state.srv_center_lng} onChange={onChange} type="text" name="srv_center_lng" placeholder="" />
        </div>
        <div className="form-group">
          <label htmlFor="expand_area_range">Expand Range (in Meters) </label>
          <input value={state.expand_area_range} onChange={onChange} type="number" name="expand_area_range" placeholder="Meters" />
        </div>
        <div className="form-group">
          <label htmlFor="password">In Charge: </label>
          <input value={state.in_charge_name} onChange={onChange} type="text" name="in_charge_name" placeholder="" />
        </div>
        <div className="form-group">
          <label htmlFor="password">Office Phone </label>
          <input value={state.office_phone} onChange={onChange} type="text" name="office_phone" placeholder="" />
        </div>
        <div className="form-group">
          <label htmlFor="password">Address </label>
          <input value={state.office_address} onChange={onChange} type="text" name="office_address" placeholder="" />
        </div>

        <div className="form-group">
          <label htmlFor="password">Email </label>
          <input value={state.email} onChange={onChange} type="text" name="email" placeholder="" />
        </div>
        
        <div className="form-group">
          <label htmlFor="password">Password </label>
          <input value={state.password} onChange={onChange} type="text" name="password" placeholder="" />
        </div>


        <Divider />


        <div className="form-group flex-justify-between">
          <label htmlFor="password">active_status</label>

          <Switch checked={state.active_status?true:false} onChange={e => {
            setState(p => ({ ...p, active_status: !p.active_status }))
          }} />
        </div>

        <div className="form-group">
          <label htmlFor="Base Fare">Base Fare </label>
          <input value={state.base_fare} onChange={onChange} type="text" name="base_fare" 
          onFocus={e => e.target.select()} 
          placeholder="" />
        </div>

        <div className="form-group">
          <label htmlFor="per_km_fare">per_km_fare </label>
          <input value={state.per_km_fare} onChange={onChange} type="text" name="per_km_fare" 
          onFocus={e => e.target.select()}
          placeholder="" />
        </div>

        <div className="form-group">
          <label htmlFor="reason">reason </label>
          <input value={state.reason} onChange={onChange} type="text" name="reason"
          onFocus={e => e.target.select()}
          placeholder="" />
        </div>

        <div className="form-group">
          <label htmlFor="zone_type">zone_type </label>
          <input value={state.zone_type} onChange={onChange} type="text" name="zone_type" 
          onFocus={e => e.target.select()}
          placeholder="" />
        </div>

        <div className="form-group">
          <label htmlFor="zone_start_time">zone_start_time </label>
          <TimePicker use12Hours
          onChange={e => {
            if(e!==null){
              setState(p => ({ ...p, zone_start_time: moment(e?.$d) }));
            }
          }}
          />
        </div>

        <div className="form-group">
          <label htmlFor="zone_close_time">zone_close_time </label>
          <TimePicker use12Hours 
          onChange={e => {
            if(e!==null){
              setState(p => ({ ...p, zone_close_time: moment(e?.$d) }));
            }
          }}
          />
        </div>

        <div className="form-group flex-justify-between">
          <label htmlFor="autometic_on_off">Autometic ON/OFF </label>
          <Switch checked={state.autometic_on_off?true:false} onChange={e => {
            setState(p => ({ ...p, autometic_on_off: !p.autometic_on_off }))
          }} />
        </div>        

        <button onClick={addServiceArea} type="button" className="btn btn-primary">{loading ? "Loading..." : "Submit"}</button>
      </form>



    </>
  )
}

export default ServiceArea